module.exports = __webpack_public_path__ + "static/media/ic-checked-in.d0d48847.svg";